/** модальное окно для выбора локализаций в требуемых случаях */
import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import IntlMessages from "util/intlMessages";
import { adminAPI } from "redux/api";
import { FloatModal } from "components/special";

const { api } = adminAPI.actions;

const FloatPartnersModal = (props) => {
  return (
    <FloatModal
      header={<IntlMessages id="Partners" />}
      {...props}
      head={(search, searchQuery, setSearchQuery) => {
        return (
          <>
            <th>
              <IntlMessages id="name" />
            </th>
            <th></th>
            <th style={{ width: "30px" }}></th>
          </>
        );
      }}
      row={(partner, clickHandler) => (
        <>
          <td onClick={clickHandler} className={!partner.enabled ? "text-strike" : ""}>
            {partner.name}
          </td>
          <td></td>
          <td></td>
        </>
      )}
    />
  );
};

const FloatPartners = (props) => {
  return <FloatPartnersModal {...props} />;
};
export default connect(null, {
  getData: api.get("/api/references/partners"),
})(FloatPartners);
